import type { Service, Testimonial, Job, TeamMember } from '../types';

export const services: Service[] = [
  {
    id: 'night-audit',
    title: 'Night-Auditor-Service',
    description: 'Professionelle nächtliche Abrechnung und Betreuung Ihrer Hotelrezeption. Verlässlich, präzise und diskret.',
    icon: 'moon',
    features: [
      'Nächtliche Abrechnung & Reports',
      'Gästebetreuung rund um die Uhr',
      'Rechnungsprüfung & Kontrolle',
      'System-Backups & Wartung',
      'Frühstücksvorbereitung',
      'Kassenabschluss & Kassensicherung',
    ],
  },
  {
    id: 'rezeption',
    title: 'Receptionsservice',
    description: 'Empfangsdienstleistungen auf höchstem Niveau – von der Reservierung bis zum Check-out.',
    icon: 'building',
    features: [
      'Check-in & Check-out',
      'Reservierungsmanagement',
      'Gästekommunikation',
      'Zimmerzuweisung & -kontrolle',
      'Zahlungsabwicklung',
      'Concierge-Services',
    ],
  },
  {
    id: 'events',
    title: 'Event-Service',
    description: 'Professioneller Support für Veranstaltungen, Kongresse und Firmenevents im Hotelbereich.',
    icon: 'calendar',
    features: [
      'Gästeregistrierung',
      'Badge-Ausgabe',
      'Informationsschalter',
      'Koordination vor Ort',
      'VIP-Betreuung',
      'Mehrsprachiger Service',
    ],
  },
];

export const testimonials: Testimonial[] = [
  {
    name: 'Sarah Müller',
    company: 'Hotel Managerin, Hyatt Regency Düsseldorf',
    text: 'ConciergeUnit hat unsere Nachtabläufe revolutioniert. Die Professionalität und Zuverlässigkeit sind herausragend. Absolut empfehlenswert!',
  },
  {
    name: 'Michael Weber',
    company: 'Operations Director, Hotel Kö59 Düsseldorf',
    text: 'Wir arbeiten seit zwei Jahren mit ConciergeUnit zusammen. Die Expertise in Opera und anderen Systemen ist beeindruckend. Ein verlässlicher Partner.',
  },
  {
    name: 'Laura Schmidt',
    company: 'Event Managerin, Congress Center Düsseldorf',
    text: 'Für unsere großen Kongresse ist ConciergeUnit unser Go-to-Partner. Flexibel, professionell und immer mit Lösungen parat.',
  },
];

export const jobs: Job[] = [
  {
    id: 'night-auditor',
    title: 'Night Auditor',
    location: 'Düsseldorf & Umgebung',
    type: 'night',
    description: 'Verantwortung für die nächtliche Abrechnung, Gästebetreuung und alle administrativen Aufgaben an der Rezeption.',
    requirements: [
      'Erfahrung in der Hotellerie wünschenswert',
      'Grundkenntnisse in PMS-Systemen von Vorteil',
      'Sehr gute Deutschkenntnisse',
      'Serviceorientierte Ausstrahlung',
      'Zuverlässigkeit und Eigenständigkeit',
    ],
    benefits: [
      'Attraktive Vergütung',
      'Flexible Einsatzzeiten',
      'Weiterbildungsmöglichkeiten',
      'Netzwerk aus Premium-Hotels',
      'Möglichkeit zur Festanstellung',
    ],
  },
  {
    id: 'empfang',
    title: 'Empfangsmitarbeiter',
    location: 'Düsseldorf & Umgebung',
    type: 'fulltime',
    description: 'Professioneller Empfang von Gästen, Check-in/Check-out, Reservierungsmanagement und Gästekommunikation.',
    requirements: [
      'Abgeschlossene Ausbildung im Hotelgewerbe oder vergleichbare Qualifikation',
      'Sicherer Umgang mit gängigen PMS-Systemen',
      'Sehr gute Deutsch- und Englischkenntnisse',
      'Ausgeprägte Serviceorientierung',
      'Stilsicheres Auftreten',
    ],
    benefits: [
      'Übernahmechancen bei Partnerhotels',
      'Attraktives Gehaltspaket',
      'Fahrtkostenzuschuss',
      'Regelmäßige Teamevents',
      'Weihnachts- und Urlaubsgeld',
    ],
  },
  {
    id: 'event',
    title: 'Event Support',
    location: 'Bundesweit',
    type: 'parttime',
    description: 'Unterstützung bei Veranstaltungen, Kongressen und Firmenevents im Hotelbereich.',
    requirements: [
      'Kommunikationsstärke und Kundenorientierung',
      'Gepflegtes Äußeres',
      'Flexibilität für kurzfristige Einsätze',
      'Deutsch und idealerweise weitere Fremdsprachen',
      'Bereitschaft zu Reisen (optional)',
    ],
    benefits: [
      'Projektbasierte Einsätze',
      'Attraktive Stundensätze',
      'Abwechslungsreiche Events',
      'Networking-Möglichkeiten',
      'Kostenlose Verpflegung vor Ort',
    ],
  },
];

export const team: TeamMember[] = [
  {
    name: 'Belbachir Soufiane',
    role: 'Gründer & Geschäftsführer',
    quote: 'Exzellenz im Service ist keine Zufälligkeit, sondern das Ergebnis bewusster Entscheidungen und harter Arbeit.',
  },
];

export const companyInfo = {
  name: 'ConciergeUnit',
  owner: 'Belbachir Soufiane',
  email: 'info@conciergeunit.de',
  phone: '+49 176 72536937',
  address: {
    street: 'Kühlwetter Straße 49',
    city: 'Düsseldorf',
    zip: '40239',
    country: 'Deutschland',
  },
  vatId: 'DE123456789', // TODO: Update with actual USt-IdNr.
  registration: 'HRB 12345 Amtsgericht Düsseldorf', // TODO: Update with actual registration
};
